<template>
  <div id="app">
    <!-- <particles-bg type="cobweb" :bg="true"/> -->
    <el-container>
      <el-header style="height: 60px;display: flex;align-items: center;">
        <Header></Header>
      </el-header>
      <!-- <el-divider></el-divider> -->
      <DividLine mode="none"></DividLine>
      <el-container>
        <el-aside width="180px">
          <LeftMenu></LeftMenu>
        </el-aside>
        <el-main style="flex:1;line-height: 1.2rem;position:relative;">
          <router-view></router-view>
        </el-main>
        
      </el-container>
      <el-footer style="font-size: 12px;line-height: 20px;">
        <DividLine mode="none"></DividLine>
        <div style="height:100%;display: flex;justify-content: center;align-items: center;">
          <a style="margin-right:15px" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">备案号：辽ICP备2024024928号-1</a>
          <img style="height: 17px;margin-right: 4px;" src="./assets/beian.png">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=21029602000893" rel="noreferrer" target="_blank">辽公网安备21029602000893号</a>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Header from './components/header.vue'
import LeftMenu from './components/leftMenu.vue'
import DividLine from './components/dividLine.vue'
//import {ParticlesBg} from "particles-bg-vue";
export default {
  name: 'App',
  components: {
    Header,
    LeftMenu,
    DividLine,
    //ParticlesBg
  },
 
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */
.el-divider{
  margin: 0 !important;
}
.el-container{
  min-height: calc(100vh - 120px);
}
.el-header, .el-footer {
    background-color: #ffffff;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  
  .el-aside {
    background-color: #f8f9fc;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  
  .el-main {
    background-color: #ffffff;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  
  body > .el-container {
    margin-bottom: 40px;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  .el-footer {
    padding: 0 !important;
  }

</style>
